import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import EmailStaticContent from '../EmailStaticContent';
import Email from '../Email';

/**
 *  ConnectedEmailOwner uses activeEmailListingDuck to get listing, owner, and preorder information from page state
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function ConnectedEmailOwner(_ref) {
  let {
    className,
    activeEmailListingDuck,
    ownerId,
    ctaProps,
    uiContext,
    selectedVrsData = {},
    trimSelected,
    ...rest
  } = _ref;
  const owners = useSelector(state => state.owners) || {};
  const preorder = useSelector(state => state?.preorder?.models) || {};
  const activeResults = useSelector(state => activeEmailListingDuck?.selectors?.getActiveResults(state));
  const activeInventory = useSelector(state => activeEmailListingDuck?.selectors?.getActiveInventory(state));
  let listing = {};
  if (Array.isArray(activeResults)) {
    if (ctaProps?.context === 'quote') {
      listing = Object.values(preorder).filter(item => item.id === activeResults[0])[0] || {};
    } else {
      // select first listing from active inventory
      [listing = {}] = activeInventory || [];
    }
  }

  // listing.owner can be undefined, null, owner id (number), or owner object that might have an id
  const listingOwner = listing.owner || listing.ownerId;
  const ownerid = (typeof listingOwner === 'object' ? listingOwner.id : listingOwner) || ownerId;
  const owner = owners[ownerid] || {};
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: /*#__PURE__*/_jsx(Email, {
      listing: listing,
      owner: owner,
      uiContext: uiContext,
      ctaProps: ctaProps,
      ...rest
    })
  });
}
export default /*#__PURE__*/memo(ConnectedEmailOwner);